import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ModalShowGiftLog from './ModalShowGiftLog';

const $ = window.$;

export default class ModalGiffts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            gifts: null,
            selectedGift: null,

            adminHistory: [],
            viewMode: "giftBag",
            cursor: null,
            loading: false
        }

        this.getAllUserGift = this.getAllUserGift.bind(this);
        this.addNewUserGift = this.addNewUserGift.bind(this);
        this.openGiftLogModal = this.openGiftLogModal.bind(this);

        this.loadAdminHistory = this.loadAdminHistory.bind(this);
        this.backToGiftBag = this.backToGiftBag.bind(this);
    }

    getAllUserGift() {
        let account = this.props.account;

        if (account) {

            let json = {
                facebookId: account.id
            }

            axios.post(global.config.apiDomain + '/rest/admin/getAllUserGift', json)
                .then(res => {

                    this.setState({
                        gifts: res.data.gifts
                    });

                })
        }
    }

    componentDidUpdate(prevProps) {

        // Đổi sang user khác -> reset giỏ quà + lịch sử admin + cursor về mặc định.
        if (prevProps.account?.id !== this.props.account?.id) {
            this.setState({
                gifts: null,
                selectedGift: null,
                adminHistory: [],
                viewMode: "giftBag",
                cursor: null,
            });
            return;
        }

        const { gifts } = this.state;

        if (!gifts) {
            this.getAllUserGift();
        }
    }

    openGiftLogModal(gift) {

        this.setState({ selectedGift: gift }, () => {
            $('#modalShowGiftLog').modal('show');
        });

    }

    addNewUserGift() {

        let giftId = document.getElementById('newUserGift').value.trim();

        if (!giftId) {
            toast.error("Nhập ID Quà");
            return;
        }

        const { gifts } = this.state;

        let existed = false;

        gifts && gifts.forEach(item => {

            if (item.id == giftId) {
                existed = true;
            }

        })

        if (existed) {
            toast.error("Quà này đã có trong túi User!");
            return;
        }

        const request = {
            giftId: giftId
        };

        axios.post(global.config.apiDomain + '/rest/gifts/getDetail', request)
            .then(res => {

                if (res.data.status == 'OK') {

                    let gift = res.data.gift;
                    gift.noItem = 0;

                    let gifts = this.state.gifts;
                    gifts.unshift(gift);

                    this.setState({
                        gifts: gifts
                    });

                } else {

                    toast.warning(res.data.message);

                }

            })
    }

    loadAdminHistory() {

        let account = this.props.account;

        let json = {
            receiverFacebookId: account.id,
            cursor: this.state.cursor
        }

        this.setState({ loading: true });

        axios.post(global.config.apiDomain + '/rest/admin/showHistoryReceiverAdminIcoin', json)
            .then(res => {

                let history = this.state.adminHistory;

                history = history.concat(res.data.receiverGifts || []);

                this.setState({
                    adminHistory: history,
                    cursor: res.data.cursor,
                    loading: false,
                    viewMode: "adminHistory"
                });

            })
            .catch(err => {

                toast.error(err.message);
                this.setState({ loading: false });

            })
    }

    backToGiftBag() {

        this.setState({
            viewMode: "giftBag",
            adminHistory: [],
            cursor: null
        });

    }

    renderAdminHistory() {

        const { adminHistory, cursor, loading } = this.state;

        return (

            <div>

                <button
                    className="btn btn-primary mb-3"
                    onClick={this.backToGiftBag}
                >
                    Giỏ quà
                </button>

                <table className="table table-bordered">

                    <thead>

                        <tr>
                            <th rowSpan="2">Ngày nhận</th>
                            <th colSpan="3">Người thao tác</th>
                            <th colSpan="8">Quà</th>
                        </tr>

                        <tr>

                            <th>UID</th>
                            <th>Tên</th>
                            <th>Avatar</th>

                            <th>ID</th>
                            <th>Tên</th>
                            <th>Ảnh</th>
                            <th>Số lượng cũ</th>
                            <th>Số lượng tặng</th>
                            <th>Số lượng mới</th>
                            <th>Giá mua</th>
                            <th>Giá bán</th>

                        </tr>

                    </thead>

                    <tbody>

                        {
                            adminHistory && adminHistory.map((record, index) => {

                                if (!record.paymentDetail?.gift) return null;

                                return (

                                    <tr key={index}>

                                        <td>{new Date(record.addTime).toLocaleString()}</td>

                                        <td>{record.paymentDetail.user?.uid}</td>

                                        <td>{record.paymentDetail.user?.name}</td>

                                        <td>

                                            <img
                                                src={record.paymentDetail.user?.profileImageLink}
                                                width="80"
                                            />

                                        </td>

                                        <td>{record.paymentDetail.gift.id}</td>

                                        <td>{record.paymentDetail.gift.name}</td>

                                        <td>

                                            <img
                                                src={record.paymentDetail.gift.url}
                                                width="80"
                                            />

                                        </td>

                                        <td>{record.noOldItem}</td>

                                        <td>{record.noItemReceived}</td>

                                        <td>{record.noNewItem}</td>

                                        <td>{record.paymentDetail.gift.buyPrice}</td>

                                        <td>{record.paymentDetail.gift.sellPrice}</td>

                                    </tr>

                                )

                            })
                        }

                    </tbody>

                </table>

                {
                    cursor !== "END" &&

                    <div
                        className="text-center"
                        style={{ cursor: "pointer" }}
                        onClick={this.loadAdminHistory}
                    >

                        {loading ? "ĐANG TẢI..." : "TẢI THÊM"}

                    </div>
                }

            </div>
        )

    }

    render() {

        const { gifts, selectedGift, viewMode } = this.state;
        const { account, readOnly } = this.props;

        if (viewMode === "adminHistory") {
            return this.renderAdminHistory();
        }

        return (

            <div>

                <div className='mt-2 mb-3 row'>

                    <div className="col-3">
                        <button
                            className="btn btn-warning"
                            onClick={this.loadAdminHistory}
                        >
                            Lịch sử quà tặng admin
                        </button>
                    </div>

                    {/* readOnly: role chỉ được xem giỏ quà, không thêm/sửa/xoá. */}
                    {!readOnly ? (
                        <>
                            <input
                                type="text"
                                className="form-control col-4"
                                placeholder="Nhập ID Quà MỚI"
                                id='newUserGift'
                            />

                            <div className='col-2'>
                                <button className='btn btn-success' onClick={this.addNewUserGift}>
                                    Thêm vào
                                </button>
                            </div>
                        </>
                    ) : <></>}

                </div>

                <table className="table">

                    <thead>

                        <tr>
                            <th>STT</th>
                            <th>ID Quà</th>
                            <th>Tên Quà</th>
                            <th>Giá Mua</th>
                            <th>Giá Bán</th>
                            <th>Image</th>
                            <th>Số lượng</th>
                            {!readOnly ? <th>Tùy chỉnh</th> : <></>}
                            <th>Chi tiết</th>
                        </tr>

                    </thead>

                    <tbody>

                        {
                            gifts && gifts.map((gift, index) => {

                                return (

                                    <tr key={gift.id}>

                                        <td>{index + 1}</td>

                                        <td>{gift.id}</td>

                                        <td>{gift.name}</td>

                                        <td>{gift.buyPrice}</td>

                                        <td>{gift.sellPrice}</td>

                                        <td>
                                            <img src={gift.url} width="75" />
                                        </td>

                                        <td>
                                            <div id={`tdValue${gift.id}`}>{gift.noItem}</div>
                                            <input type="number" className="form-control" id={`tdInput${gift.id}`} hidden />
                                        </td>

                                        {/* Nút Lưu + Hủy (hiện khi đang sửa) */}
                                        {/* Cụm Sửa/Xoá số lượng quà - ẩn với role chỉ được xem. */}
                                        {!readOnly ? (<>
                                        <td id={`tdUpdate${gift.id}`} hidden>
                                            <button
                                                className='btn btn-success ml-2 mr-2'
                                                name={index}
                                                onClick={(e) => {
                                                    let idx = e.target.name;
                                                    let value = document.getElementById(`tdInput${gift.id}`).value;
                                                    let json = {
                                                        userId: account.id,
                                                        giftId: gift.id,
                                                        value: value
                                                    }
                                                    let tdInput = document.getElementById(`tdInput${gift.id}`);
                                                    let tdUpdate = document.getElementById(`tdUpdate${gift.id}`);
                                                    let tdValue = document.getElementById(`tdValue${gift.id}`);
                                                    let tdEdit = document.getElementById(`tdEdit${gift.id}`);

                                                    if (value < 0) {
                                                        return toast.warning("Không thể nhập số âm !");
                                                    }

                                                    if (window.confirm("Bạn có chắc là muốn thay đổi ?")) {
                                                        axios.post(global.config.apiDomain + '/rest/gifts/updateUserGift', json)
                                                            .then(res => {
                                                                if (res.data.status === "OK") {
                                                                    tdUpdate.setAttribute("hidden", true);
                                                                    tdInput.setAttribute("hidden", true);
                                                                    tdValue.removeAttribute('hidden');
                                                                    tdEdit.removeAttribute('hidden');

                                                                    gift.noItem = value;
                                                                    gifts[idx] = gift;
                                                                    this.setState({ gifts: gifts });
                                                                    return toast.success(res.data.message);
                                                                } else {
                                                                    return toast.error(res.data.message || "Cập nhật thất bại");
                                                                }
                                                            }).catch(err => {
                                                                toast.error(err.message);
                                                            })
                                                    }
                                                }}
                                            >
                                                Lưu
                                            </button>
                                            <button
                                                className='btn btn-primary'
                                                onClick={() => {
                                                    let tdInput = document.getElementById(`tdInput${gift.id}`);
                                                    let tdUpdate = document.getElementById(`tdUpdate${gift.id}`);
                                                    let tdValue = document.getElementById(`tdValue${gift.id}`);
                                                    let tdEdit = document.getElementById(`tdEdit${gift.id}`);
                                                    tdUpdate.setAttribute("hidden", true);
                                                    tdInput.setAttribute("hidden", true);
                                                    tdValue.removeAttribute('hidden');
                                                    tdEdit.removeAttribute('hidden');
                                                }}
                                            >
                                                Hủy
                                            </button>
                                        </td>

                                        {/* Nút Sửa + Xóa (mặc định hiện) */}
                                        <td id={`tdEdit${gift.id}`}>
                                            <button
                                                className='btn btn-info ml-2 mr-2'
                                                onClick={() => {
                                                    let tdInput = document.getElementById(`tdInput${gift.id}`);
                                                    let tdUpdate = document.getElementById(`tdUpdate${gift.id}`);
                                                    let tdValue = document.getElementById(`tdValue${gift.id}`);
                                                    let tdEdit = document.getElementById(`tdEdit${gift.id}`);
                                                    tdEdit.setAttribute("hidden", true);
                                                    tdValue.setAttribute("hidden", true);
                                                    tdInput.removeAttribute('hidden');
                                                    tdInput.value = gift.noItem;
                                                    tdUpdate.removeAttribute('hidden');
                                                }}
                                            >
                                                Sửa
                                            </button>
                                            <button
                                                className='btn btn-danger'
                                                name={index}
                                                onClick={(e) => {
                                                    if (window.confirm("Bạn có chắc là muốn xóa ?")) {
                                                        let json = {
                                                            userId: account.id,
                                                            giftId: gift.id
                                                        }
                                                        axios.post(global.config.apiDomain + '/rest/gifts/deleteUserGift', json)
                                                            .then(res => {
                                                                let tdInput = document.getElementById(`tdInput${gift.id}`);
                                                                let tdUpdate = document.getElementById(`tdUpdate${gift.id}`);
                                                                let tdValue = document.getElementById(`tdValue${gift.id}`);
                                                                let tdEdit = document.getElementById(`tdEdit${gift.id}`);
                                                                tdUpdate.setAttribute("hidden", true);
                                                                tdInput.setAttribute("hidden", true);
                                                                tdValue.removeAttribute('hidden');
                                                                tdEdit.removeAttribute('hidden');

                                                                gift.noItem = 0;
                                                                gifts[index] = gift;
                                                                this.setState({ gifts: gifts });
                                                                return toast.success(res.data.message);
                                                            }).catch(err => {
                                                                toast.error(err.message);
                                                            })
                                                    }
                                                }}
                                            >
                                                Xóa
                                            </button>
                                        </td>
                                        </>) : <></>}

                                        <td>
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={() => this.openGiftLogModal(gift)}
                                            >
                                                <i className="fa fa-eye"></i>
                                            </button>
                                        </td>

                                    </tr>

                                )

                            })
                        }

                    </tbody>

                </table>

                {
                    selectedGift &&

                    <ModalShowGiftLog
                        userId={account.id}
                        giftId={selectedGift.id}
                        quantity={selectedGift.noItem}
                    />

                }

            </div>

        )

    }
}